import { RouteObject } from 'react-router';

import {
  EventCalendarModuleRoutes,
  MarketplaceEventModuleRoutes,
  ProductModuleRoutes,
  SalesChannelModuleRoutes,
  AdvertisingModuleRoutes,
  InventoryStockValueModuleRoutes,
  InventoryTrackerModuleRoutes,
  SalesChannelAnalyticModuleRoutes,
} from './modules';

export const routes: RouteObject[] = [
  ...SalesChannelModuleRoutes,
  ...SalesChannelAnalyticModuleRoutes,
  ...ProductModuleRoutes,
  ...MarketplaceEventModuleRoutes,
  ...EventCalendarModuleRoutes,
  ...AdvertisingModuleRoutes,
  ...InventoryStockValueModuleRoutes,
  ...InventoryTrackerModuleRoutes,
];
